import { Spinner, styled } from '@arpeggi/ui'

const Root = styled('div', {
  background: '$white',
  overflow: 'hidden',
  borderRadius: '12px',
  borderStyle: 'solid',
  borderColor: '$blackA100',
  position: 'relative'
})

const Content = styled('div', {
  padding: '24px'
})

const Loader = styled(Spinner, {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
})

const Text = styled('div', {
  fontSize: '$14',
  lineHeight: '32px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  variants: {
    bold: {
      true: {
        fontWeight: 700
      }
    },
    title: {
      true: {
        fontWeight: 700,
        fontSize: '$20',
        lineHeight: '20px',
        marginBottom: '24px',
        letterSpacing: '-0.025em'
      }
    },
    slimMargin: {
      true: {
        marginBottom: '12px'
      }
    },
    muted: {
      true: {
        opacity: '50%'
      }
    }
  }
})

const Link = styled('a', {
  fontSize: '14px',
  lineHeight: '20px',
  display: 'flex',
  fontWeight: 500,
  color: '#2181E2',
  alignItems: 'center'
})

const Row = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between'
})

export const Card = { Root, Content, Loader, Text, Link, Row }
